import React, { useState, useEffect } from 'react';
import { Row, Col, Button } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faSave } from '@fortawesome/free-solid-svg-icons';

//Components
import TabelaEnderecos from './TabelaEnderecos';
import TextField from '../../../../components/TextField/TextField';
import CustomizedMap from '../../../../components/CustomizedMap/CustomizedMap';

//Api
import setor_api from '../../../../api/setor_api';
import cep_api from '../../../../api/cep_api';
import gerador_api from '../../../../api/gerador_api';

//Helpers
import mascaras from '../../../../helpers/mascaras';
import { validarCampos, objCampo } from '../../../../helpers/ValidadorDeCampos';
import { showMessage, showQuestion } from '../../../../helpers/message';

//Context
import { useAuth } from '../../../../context/auth';
import setup_api from 'api/setup_api';
import usuario_api from 'api/usuario_api';
import moment from 'moment';
import ModalCustomized from 'components/Modal/Modal';
import TabelaListagem from 'components/TabelaListagem/TabelaListagem';

function initialStateEndereco({ principal }) {
    return {
        identificacao: "",
        cpfcnpj: "",
        cep: "",
        uf: "",
        cidade: "",
        bairro: "",
        logradouro: "",
        numero: "",
        complemento: "",
        tbSetores_id: "",
        localidadePadrao: principal === "Sim",
        latitude: "",
        longitude: "",
        principal: principal,
        status: "Ativo",
        editEndereco: true,
        removeEndereco: true,
        contratos: []
    }
}
export default function Enderecos({ gerador, setGerador, openForm, setOpenForm, modulo, integracaoCadastros, disabledCampos = false }) {
    //Estado de controle do loading na tela
    const { session, setLoading } = useAuth();

    //Estado de controle para campos de endereço
    const [endereco, setEndereco] = useState(initialStateEndereco({ principal: "Sim" }));

    //Estado de controle de erros nos campos do endereco
    const [errors, setErrors] = useState({});

    //Estado de controle das opções de regionais
    const [regionais, setRegionais] = useState([
        { value: "", text: "Selecione" },
    ]);

    const [setup, setSetup] = useState()

    //Modalidades que o transportador pode fechar contrato
    const [modalidades, setModalidades] = useState([]);

    //Carrega as regionais da prefeitura selecionada na tela anterior
    useEffect(() => {
        setor_api.GetList(gerador.tbPrefeituras_id).then(response => {
            const _regionais = response.data.map(regional => {
                return { value: regional.id == null ? null : regional.id.toString(), text: regional.descricao };
            })
            setRegionais([...regionais, ..._regionais])
        }).catch(e => showMessage("Aviso", e.message, "error", null));
        if (modulo === "Transportador") {
            gerador_api.GetModalidadesContratos().then(response => {
                setModalidades(response.data);
            }).catch(e => showMessage("Aviso", e.message, "error"));
        }
        gerador.localidades = gerador.localidades.map(localidade => {
            if (localidade.localidadePadrao) {
                setEndereco({
                    ...endereco,
                    localidadePadrao: false,
                    principal: "Não"
                })
            }
            return { ...localidade, principal: localidade.localidadePadrao ? "Sim" : "Não" }
        })
    }, []);

    //Limpa os erros dos campos ao fechar o formulario
    useEffect(() => {
        if (!openForm) {
            setErrors({});
        }
        loadSetup();
    }, [openForm]);

    //campos obrigatorios do cadastro de endereço
    const campos = [
        objCampo({ name: "identificacao", required: true }),
        objCampo({ name: "cpfcnpj", required: true, cpfcnpj: true }),
        objCampo({ name: "cep", required: true }),
        objCampo({ name: "uf", required: true }),
        objCampo({ name: "cidade", required: true }),
        objCampo({ name: "bairro", required: true }),
        objCampo({ name: "logradouro", required: true }),
        objCampo({ name: "numero", required: true }),
    ]

    //Change para os campos do formulario de endereço
    const onChangeEndereco = (e) => {
        const { name, value } = e.target;
        const _endereco = { ...endereco, [name]: value };
        const campo = campos.filter(c => c.name === name);
        const erros = validarCampos(_endereco, campo);
        if (erros[1].length == 0) {
            const _errors = { ...errors };
            delete _errors[name];
            setErrors(_errors);
        } else {
            setErrors({ ...errors, ...erros[0] });
        }
        setEndereco(_endereco);
    }

    //OnBlur para o campo de cep do endereço
    const onBlurCep = (e) => {
        const { name, value } = e.target;
        const _endereco = {
            ...endereco,
            [name]: value
        }
        _endereco.cep = mascaras.cepMask(_endereco.cep, true);
        if (_endereco.cep.length == 8) {
            setLoading(true);
            cep_api.get(_endereco.cep).then(response => {
                _endereco.bairro = response.data.bairro;
                _endereco.uf = response.data.uf;
                _endereco.logradouro = response.data.logradouro;
                _endereco.cidade = response.data.localidade;

                const erros = validarCampos(_endereco, campos);
                setErrors(erros[0]);
                const endereco = {
                    NumeroCep: _endereco.cep,
                    Bairro: _endereco.bairro,
                    Logradouro: _endereco.logradouro,
                    Cidade: _endereco.cidade,
                    Estado: _endereco.estado,
                    Numero: _endereco.numero,
                    Latitude: "",
                    Longitude: "",
                    EnderecoFormatado: "",
                }

                setLoading(true);
                cep_api.GeoCode(endereco).then(response => {
                    if (response.data.latitude && response.data.longitude) {
                        _endereco.latitude = parseFloat(response.data.latitude.replace(",", "."));
                        _endereco.longitude = parseFloat(response.data.longitude.replace(",", "."));
                        _endereco.cidade = response.data?.cidade
                    }
                    let obj = {
                        latitude: _endereco.latitude?.toString() ?? "",
                        longitude: _endereco.longitude?.toString() ?? "",
                        bairro: _endereco.bairro,
                        cidade: _endereco.cidade,
                    }
                    setor_api.GetRegionalByLocalidade(obj).then(response => {
                        if (response.data != null && response.data != "") {
                            _endereco.tbSetores_id = response.data.id;
                            _endereco.tbSetores_Descricao = response.data.descricao;
                        } else {
                            showMessage("Aviso", "a regional não foi localizado, verifique o cadastro de bairros.", "error", null);
                            return;
                        }
                        setEndereco(_endereco);
                    }).catch(e => showMessage("Aviso", e.message, "error", null))
                        .finally(f => setLoading(false));
                }).catch(e => {
                    showMessage("Aviso", e.message, "error", null);
                }).finally(f => setLoading(false));
            }).catch(e => {
                showMessage("Aviso", "CEP não encontrado na base de dados", "error", null);
            }).finally(f => setLoading(false));
        }
    }
    //Change para o mapa pegando a longitude e latitude
    const onChangeLocation = (location) => {
        let obj = {
            latitude: location.lat?.toString() ?? "",
            longitude: location.lng?.toString() ?? "",
            bairro: "",
        }
        setor_api.GetRegionalByLocalidade(obj).then(response => {
            if (response.data != null) {
                endereco.tbSetores_id = response.data.id;
                endereco.tbSetores_Descricao = response.data.descricao;
            }
            setEndereco({ ...endereco, latitude: location.lat, longitude: location.lng })
        }).catch(e => showMessage("Aviso", e.message, "error", null))
            .finally(f => setLoading(false));
    }

    //Função executada ao clicar em editar endereço
    const onClickEditarEndereco = (item) => {
        setOpenForm(true);
        item.tbSetores_id = item.tbSetores_id == null ? null : item.tbSetores_id.toString();
        setEndereco({ ...item });
    }

    const loadSetup = () => {
        setup_api.GetVariaveisSetup()
        .then(response => {
            setSetup(response.data)
        })
        .catch(err => showMessage("Erro", "Error na operação.", "error", null));
    }

    //Função executada ao clicar em adicionar novo endereço
    function addNovoEndereco() {  
        if (gerador.localidades.filter(x => (!endereco.id || x.id != endereco.id) && x.cep === endereco.cep && x.logradouro === endereco.logradouro && x.numero === endereco.numero).length > 0) {
            showMessage("Aviso", "Já existe um endereço adicionado com esses dados", "info", null);
            return;
        }

        const erros = validarCampos(endereco, campos);
        setErrors(erros[0]);
        if (erros[1].length === 0) {
            let localidades = [];

            if (!endereco.tableData) {
                const _endereco = { ...endereco };
                _endereco.contratos = []
                const aprovacaoAutomatica = gerador.aprovacaoAutomaticaCategoria === true;
                _endereco.status = (!aprovacaoAutomatica && setup?.requerAnaliseGeradorLocalidade && session?.acesso?.sigla != "GS") ? "Pendente" : "Ativo";
                modalidades.map(value => {
                    _endereco.contratos.push({
                        id: 0,
                        tbGeradores_Id: "",
                        tbTipoColeta_Id: value.id,
                        modalidade: value.descricao,
                        frequencia: "",
                        calendario: "",
                        situacaoContrato: "Sem Contrato",
                        quantidadeContratada: "",
                        tbGeradorLocalidade_id: "",
                        tbVolumetria_ID: "",
                        unidadeMedida: "",
                        inicioVigencia: "",
                        terminoVigencia: "",
                        numeroContrato: "",
                        anexo: "",
                        dataCadastro: "",
                        usuarioAtualizacao: "",
                        dataAtualizacao: "",
                        editContrato: "",
                    });
                })
                localidades = [...gerador.localidades, _endereco];
            } else {
                const _enderecos = [...gerador.localidades];
                const aprovacaoAutomatica = gerador.aprovacaoAutomaticaCategoria === true;
                endereco.status = (!aprovacaoAutomatica && setup?.requerAnaliseGeradorLocalidade && session?.acesso?.sigla != "GS") ? "Pendente" : endereco.status;
                endereco.requerAnaliseGeradorLocalidade = setup?.requerAnaliseGeradorLocalidade;
                _enderecos[endereco.tableData.id] = endereco;
                localidades = _enderecos;
            }
            if (endereco.localidadePadrao) {
                const _gerador = { ...gerador };
                _gerador.logradouro = endereco.logradouro;
                _gerador.numero = endereco.numero;
                _gerador.complemento = endereco.complemento;
                _gerador.bairro = endereco.bairro;
                _gerador.cidade = endereco.cidade;
                _gerador.uf = endereco.uf;
                _gerador.cep = endereco.cep;
                _gerador.gps = `${endereco.latitude};${endereco.longitude}`;
                _gerador.tbSetores_id = endereco.tbSetores_id;
                setGerador({ ..._gerador, localidades });
            } else {
                setGerador({ ...gerador, localidades });
            }

            setEndereco(initialStateEndereco({ principal: "Não" }));
            setOpenForm(!openForm);
        }
    }

    //Função excutada ao clicar no botão de cancelar do formulario de cadastro
    function cancelarCadastro() {
        setEndereco(initialStateEndereco({ principal: "Não" }));
        setOpenForm(!openForm);
    }
    //Função para remover um endereço recem adicionado da lista
    function removerEndereco(rowData) {
        showQuestion("Aviso",
            `Tem certeza que deseja remover esse registro? essa ação não poderá ser desfeita `,
            "info", (confirmation) => removerEnderecoConfirmation(confirmation, rowData));

    }
    function removerEnderecoConfirmation(confirmation, rowData) {
        if (confirmation) {
            const _gerador = { ...gerador };
            _gerador.localidades = _gerador.localidades.filter((value, index) => { return rowData.tableData.id !== index });
            setGerador(_gerador);
        }
    }

    const [visualizarModalAnalise, setVisualizarModalAnalise] = useState(0)
    const [fichaAnaliseLocalidade, setFichaAnaliseLocalidade] = useState()

    //Cabeçalhos da tabela de listagem de ações 
    const headersTabela = [
        { value: "Data/Hora", objectValue: "dataHora", align: "left" },
        { value: "Status", objectValue: "status", align: "left" },
        { value: "Motivo", objectValue: "observacoes", align: "left" },
    ];

    //Controle de exibição do modal de recusa na tela
    const toggleModalFicaAnalise = () => {
        setVisualizarModalAnalise(!visualizarModalAnalise);
    };

    // Função para exibir o modal do histórico de análises da localidade
    const visualizarAnaliseLocalidade = (localidade_Id) => {
        setVisualizarModalAnalise(true);
        setLoading(true);
    
        gerador_api.GetAnaliseLocalidade(localidade_Id)
            .then(response => {
                return Promise.all(response.data.map(async m => {
                    const nomeUsuario = await usuario_api.getItem(m.tbUsuarios_Id).then(retorno => retorno.data.nome);
                    return {
                        ...m,
                        dataHora: moment(m.dataHora).format("DD/MM/YYYY HH:mm:ss"),
                        nomeUsuario: nomeUsuario
                    };
                }));
            })
            .then(dataFormatada => {
                setFichaAnaliseLocalidade(dataFormatada);
            })
            .catch(e => showMessage("Aviso", e.message, "error", null))
            .finally(() => setLoading(false));
    };

    return (
        <div className='m-4 p-2 containerStep rounded-3 '>
            <div className={`formContainer mb-4 ${openForm ? "" : "close"}`}>
                <ModalCustomized 
                    title={"Ficha Análise Localidade"} 
                    isOpen={visualizarModalAnalise} 
                    toggle={toggleModalFicaAnalise} 
                    btnActionColor={"success"} btnClose
                >
                    <TabelaListagem
                        title="Histórico"
                        headers={headersTabela}
                        items={fichaAnaliseLocalidade}
                        options={{
                            print: false,
                            search: false,
                            pagination: false
                        }}
                    />
                </ModalCustomized>
                <Row>
                    <Col md={"12"} lg={"4"}>
                        <TextField label={"* Identificação"}
                            disabled={disabledCampos}
                            maxLength={"250"}
                            invalid={errors.identificacao ? true : false}
                            name="identificacao"
                            value={endereco.identificacao}
                            onChange={onChangeEndereco}
                        />
                        {errors.identificacao && <span className={"form-control-label text-danger"}>{errors.identificacao.message}</span>}
                    </Col>
                    <Col md={"12"} lg={"4"}>
                        <TextField
                            label={"* CPF/CNPJ"}
                            maxLength={"18"}
                            disabled={disabledCampos}
                            mask={mascaras.cpfcnpjMask}
                            invalid={errors.cpfcnpj ? true : false}
                            name="cpfcnpj"
                            value={endereco.cpfcnpj}
                            onChange={onChangeEndereco}
                        />
                        {errors.cpfcnpj && <span className={"form-control-label text-danger"}>{errors.cpfcnpj.message}</span>}
                    </Col>
                    <Col md={"12"} lg={"4"}>
                        <TextField
                            label={"* CEP"}
                            maxLength={"9"}
                            disabled={disabledCampos}
                            mask={mascaras.cepMask}
                            invalid={errors.cep ? true : false}
                            name="cep"
                            value={endereco.cep}
                            onChange={onChangeEndereco}
                            onBlur={onBlurCep}
                        />
                        {errors.cep && <span className={"form-control-label text-danger"}>{errors.cep.message}</span>}
                    </Col>
                    <Col md={"12"} lg={"4"}>
                        <TextField
                            label={"* UF"}
                            maxLength={"2"}
                            disabled={disabledCampos}
                            invalid={errors.uf ? true : false}
                            name="uf"
                            value={endereco.uf}
                            onChange={onChangeEndereco}
                        />
                        {errors.uf && <span className={"form-control-label text-danger"}>{errors.uf.message}</span>}
                    </Col>
                    <Col md={"12"} lg={"4"} >
                        <TextField
                            label={"* Cidade"}
                            maxLength={"150"}
                            disabled={disabledCampos}
                            invalid={errors.cidade ? true : false}
                            name="cidade"
                            value={endereco.cidade}
                            onChange={onChangeEndereco}
                        />
                        {errors.cidade && <span className={"form-control-label text-danger"}>{errors.cidade.message}</span>}
                    </Col>
                    <Col md={"12"} lg={"4"}>
                        <TextField
                            label={"* Bairro"}
                            maxLength={"100"}
                            disabled={disabledCampos}
                            invalid={errors.bairro ? true : false}
                            name="bairro"
                            value={endereco.bairro}
                            onChange={onChangeEndereco}
                        />
                        {errors.bairro && <span className={"form-control-label text-danger"}>{errors.bairro.message}</span>}
                    </Col>
                    <Col md={"12"} lg={"4"}>
                        <TextField
                            label={"* Logradouro"}
                            maxLength={"300"}
                            invalid={errors.logradouro ? true : false}
                            name="logradouro"
                            disabled={disabledCampos}
                            value={endereco.logradouro}
                            onChange={onChangeEndereco}
                        />
                        {errors.logradouro && <span className={"form-control-label text-danger"}>{errors.logradouro.message}</span>}
                    </Col>
                    <Col md={"12"} lg={"4"}>
                        <TextField
                            label={"* Número"}
                            maxLength={"50"}
                            disabled={disabledCampos}
                            invalid={errors.numero ? true : false}
                            name="numero"
                            value={endereco.numero}
                            onChange={onChangeEndereco}
                            mask={mascaras.numeroMask}
                            onBlur={onBlurCep}
                        />
                        {errors.numero && <span className={"form-control-label text-danger"}>{errors.numero.message}</span>}
                    </Col>
                    <Col md={"12"} lg={"4"}>
                        <TextField
                            label={"Complemento"}
                            maxLength={"200"}
                            disabled={disabledCampos}
                            invalid={errors.complemento ? true : false}
                            name="complemento" value={endereco.complemento}
                            onChange={onChangeEndereco}
                        />
                        {errors.complemento && <span className={"form-control-label text-danger"}>{errors.complemento.message}</span>}
                    </Col>
                    <Col md={"12"} lg={"4"}>
                        <TextField
                            label={"*Regional"}
                            disabled={disabledCampos}
                            type={"text"}
                            name="tbSetores_id"
                            value={endereco.tbSetores_Descricao}
                        />
                    </Col>
                </Row>
                <Row className='d-flex align-items-center justify-content-center'>
                    <Col md="12" lg="12" className=' shadow rounded-3 overflow-hidden m-0 p-0' style={{ width: "80%", height: "250px" }}>
                        <CustomizedMap
                            positionCenter
                            addNewMarker
                            position={{ lat: endereco.latitude, lng: endereco.longitude }}
                            setPosition={onChangeLocation}
                        />
                    </Col>
                </Row>
                <Row>
                    <Col md={"12"} lg={"12"} className={"d-flex align-items-center justify-content-center"}>
                        {!integracaoCadastros &&
                            <Button
                                color='success'
                                className=' mt-4 fw-bold bg-gradient'
                                onClick={addNovoEndereco}
                                disabled={disabledCampos}
                            >
                                {endereco.index ? <><FontAwesomeIcon className='me-2' icon={faEdit} /> Editar</> : <><FontAwesomeIcon className='me-2' icon={faSave} /> Salvar</>}
                            </Button>}
                        <Button
                            color='secondary'
                            className=' mt-4 ms-4 fw-bold bg-gradient'
                            onClick={cancelarCadastro}>
                            Cancelar
                        </Button>
                    </Col>
                </Row>
            </div>
            <TabelaEnderecos
                enderecos={[...gerador.localidades]}
                editarEndereco={onClickEditarEndereco}
                removerEndereco={removerEndereco}
                integracaoCadastros={integracaoCadastros}
                visualizarAnaliseLocalidade={visualizarAnaliseLocalidade}
            />

        </div>
    );
}